"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDelayedTask = void 0;
var IkeDelayedTask = /** @class */ (function () {
    function IkeDelayedTask(func, ms) {
        if (ms === void 0) { ms = 0; }
        this.func = func;
        this.ms = ms;
    }
    Object.defineProperty(IkeDelayedTask.prototype, "isActive", {
        get: function () {
            return this.timeoutId != null;
        },
        enumerable: false,
        configurable: true
    });
    IkeDelayedTask.prototype.delay = function (ms) {
        if (ms === void 0) { ms = this.ms; }
        var nextTime = Date.now() + ms;
        // Dont re-make the timeout if the next timeout is within X ms
        if (this.isActive) {
            var diffTime = Math.abs(nextTime - this.nextTime);
            if (diffTime < 5) {
                return;
            }
        }
        this.cancel();
        this.timeoutId = setTimeout(this.func, ms);
        this.nextTime = nextTime;
    };
    IkeDelayedTask.prototype.run = function () {
        this.cancel();
        this.func();
    };
    IkeDelayedTask.prototype.cancel = function () {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        this.nextTime = null;
    };
    return IkeDelayedTask;
}());
exports.IkeDelayedTask = IkeDelayedTask;
//# sourceMappingURL=delayed.task.js.map